import { useContext } from 'react';
import { useWatch } from 'react-hook-form';

import { useLanguage } from 'assets/languages';
import TextInputField from 'components/textInput';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import CampaignFormField from '../../../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';

const MAX_LENGTH = 100;

const MandatoryPhraseField = () => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);

  const mandatoryPhrasesValue = useWatch({
    control: guidelineRuleFormMethods.control,
    name: 'MANDATORY_PHRASE.value',
  }) as string;

  return (
    <CampaignFormField
      label={languageTexts.create_mandatory_phrases_prompt}
      description={
        <>
          {languageTexts.create_mandatory_phrases_description}&nbsp;
          <span className="text-black">
            {languageTexts._create_max_length_indicator(
              mandatoryPhrasesValue?.length || 0,
              MAX_LENGTH,
            )}
          </span>
        </>
      }
    >
      {/* 포스팅에 꼭 들어가야할 필수 문구 */}
      <TextInputField
        bordered
        inputStyle={{ fontSize: '14px' }}
        placeholder={languageTexts.create_discount_message}
        value={mandatoryPhrasesValue || ''}
        onChangeText={(value) => {
          guidelineRuleFormMethods.setValue('MANDATORY_PHRASE.value', value);
        }}
      />
    </CampaignFormField>
  );
};

export default MandatoryPhraseField;
